<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("promotionsandoffer") }}
      </div>
      <div>
        <template v-if="cinema_manager_add_edit_disabled != 3">
          <router-link
            class="btn-blue"
            @click.native="onEditPromotionOffer"
            to
            >{{ $t("edit") }}</router-link
          >
        </template>
        <router-link class="btn-blue" to="promotions-and-offers"
          >{{ $t("promotionsandoffer") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <!-- BUY AND GET FREE -->

    <div
      v-if="selectedOfferType === 'buyAndGetFreeTickets'"
      class="voucher-card"
    >
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="all-details-container">
            <div class="col-12">
              <p class="mb-1">
                <span class="font-weight-bold mr-1"
                  >{{ $tc("minimumTicketAmount") }} :</span
                >
                {{ buyAndGetFreeTickets.oc_min_ticket_price }}
              </p>
              <p class="mb-1">
                <span class="font-weight-bold mr-1"
                  >{{ $t("maximumfreeticketpertransaction") }} :</span
                >
                {{ buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction }}
              </p>
            </div>
          </div>
          <div class="voucher-label">
            {{ $t("buy") }}&nbsp;
            {{ buyAndGetFreeTickets.oc_buy_no_of_ticket }}
            &nbsp;{{ $t("tickets") }} and {{ $t("get") }}&nbsp;
            {{ buyAndGetFreeTickets.oc_get_free_ticket }}
            &nbsp;{{ $t("ticket") }} {{ $t("free") }}
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 align-self-center">
          <div class="all-details-container">
            <div class="col-12">
              <h3 class="text-blue font-weight-bold mb-3">
                {{ PromotionsDetailsObj.offer_title }}
              </h3>

              <div class="mb-4">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("code") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_code }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("start") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("end") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_applicable_on }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("name") }} :</span
                  >
                  {{ PromotionsDetailsObj.client_name }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("share") }}
                    {{ $t("vlaue") }} :</span
                  >
                  {{ PromotionsDetailsObj.share_value }}
                  {{
                    PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                  }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("redemptionOutlet") }} :</span
                  >
                  {{ $t("redeemAtOnline") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_online === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtConcession") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{ PromotionsDetailsObj.CinemasList }}.
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                  >
                  {{ PromotionsDetailsObj.ScreenList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                  >
                  {{ PromotionsDetailsObj.SeatTypesList }}.
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_movies === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{ PromotionsDetailsObj.MoviesList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("all") }}
                    {{ $t("days") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  class="mb-1"
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                  "
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offerValidOnDays") }} :</span
                  >
                  {{ PromotionsDetailsObj.DaysList }}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DISCOUNT -->
    <div v-if="selectedOfferType === 'discount'">
      <div
        v-for="(DiscountItem, DoccountIndex) in discountLists"
        :key="DoccountIndex"
        class="voucher-card"
      >
        <div class="row">
          <div class="col-lg-5 col-xl-4">
            <div class="all-details-container">
              <div class="col-12">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("maxdiscountpertransaction") }} :</span
                  >
                  {{ DiscountItem.oc_max_discount_amount }}
                </p>
              </div>
            </div>
            <div class="voucher-label">
              {{ $t("buy") }}&nbsp;
              {{ DiscountItem.oc_buy_no_of_ticket }}
              &nbsp;{{ $t("tickets") }} and {{ $t("get") }}
              {{ $t("discount") }} of&nbsp;
              {{ DiscountItem.oc_discount_value }}
              &nbsp;
              {{
                DiscountItem.oc_discount_value_is_percentage === "Y" ? "%" : ""
              }}
            </div>
          </div>
          <div class="col-lg-7 col-xl-8 align-self-center">
            <div class="all-details-container">
              <div class="col-12">
                <h3 class="text-blue font-weight-bold mb-3">
                  {{ PromotionsDetailsObj.offer_title }}
                </h3>

                <div class="mb-4">
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("code") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_code }}
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("start") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("end") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("applicableOn") }}:</span
                    >
                    {{ PromotionsDetailsObj.offer_applicable_on }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("client") }} {{ $t("name") }} :</span
                    >
                    {{ PromotionsDetailsObj.client_name }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("client") }} {{ $t("share") }}
                      {{ $t("vlaue") }} :</span
                    >
                    {{ PromotionsDetailsObj.share_value }}
                    {{
                      PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                    }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("redemptionOutlet") }} :</span
                    >
                    {{ $t("redeemAtOnline") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_online === "Y"
                        ? "Yes"
                        : "No"
                    }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                        ? "Yes"
                        : "No"
                    }},&nbsp; {{ $t("redeemAtConcession") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>

                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                        'Y'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                      "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                        'N'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                    >
                    {{ PromotionsDetailsObj.CinemasList }}.
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                    >
                    {{ PromotionsDetailsObj.ScreenList }}.
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                    >
                    {{ PromotionsDetailsObj.SeatTypesList }}.
                  </p>

                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                        'Y'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                      "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                        'N'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                    >
                    {{ PromotionsDetailsObj.MoviesList }}.
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("all") }}
                      {{ $t("days") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>

                  <p
                    class="mb-1"
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                    "
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offerValidOnDays") }} :</span
                    >
                    {{ PromotionsDetailsObj.DaysList }}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        selectedOfferType === 'buyAndGetCombo' &&
          offerApplicableAt === 'boxOffice'
      "
      class="voucher-card"
    >
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="all-details-container">
            <div class="col-12">
              <p class="mb-1">
                <span class="font-weight-bold mr-1"
                  >{{ $t("combinewith") }} :</span
                >
                {{ $t("boxoffice") }}
              </p>
            </div>
          </div>
          <div class="voucher-label">
            {{ $t("buy") }}&nbsp;
            {{ boxOffice.oc_buy_no_of_ticket }}
            &nbsp;{{ $t("tickets") }} and {{ $t("get") }}t&nbsp;
            {{ boxOffice.oc_get_item_id }}
            &nbsp;{{ $t("item") }}.
            <br />
            is {{ $t("free") }}:
            {{ boxOffice.oc_is_combo_free === "Y" ? " Yes" : "No" }}.&nbsp;
            <br />
            {{ $t("discount") }}: {{ boxOffice.oc_discount_value }}&nbsp;{{
              boxOffice.oc_discount_value_is_percentage === "Y" ? "%" : ""
            }}
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 align-self-center">
          <div class="all-details-container">
            <div class="col-12">
              <h3 class="text-blue font-weight-bold mb-3">
                {{ PromotionsDetailsObj.offer_title }}
              </h3>

              <div class="mb-4">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("code") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_code }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("start") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("end") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_applicable_on }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("name") }} :</span
                  >
                  {{ PromotionsDetailsObj.client_name }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("share") }}
                    {{ $t("vlaue") }}:</span
                  >
                  {{ PromotionsDetailsObj.share_value }}
                  {{
                    PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                  }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("redemptionOutlet") }} :</span
                  >
                  {{ $t("redeemAtOnline") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_online === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtConcession") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{ PromotionsDetailsObj.CinemasList }}.
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                  >
                  {{ PromotionsDetailsObj.ScreenList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                  >
                  {{ PromotionsDetailsObj.SeatTypesList }}.
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_movies === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{ PromotionsDetailsObj.MoviesList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("all") }}
                    {{ $t("days") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  class="mb-1"
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                  "
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offerValidOnDays") }} :</span
                  >
                  {{ PromotionsDetailsObj.DaysList }}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        selectedOfferType === 'buyAndGetCombo' && offerApplicableAt === 'fAndb'
      "
      class="voucher-card"
    >
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="all-details-container">
            <div class="col-12">
              <p class="mb-1">
                <span class="font-weight-bold mr-1"
                  >{{ $t("combinewith") }} :</span
                >
                F&amp;B
              </p>
            </div>
          </div>

          <div class="voucher-label">
            {{ $t("buy") }}&nbsp; {{ F_And_B.oc_buy_item_count }}&nbsp;
            {{ F_And_B.oc_buy_item_id }}&nbsp; {{ $t("item") }} and
            {{ $t("get") }}t&nbsp; {{ F_And_B.oc_get_item_count }}&nbsp;
            {{ F_And_B.oc_get_item_id }}
            &nbsp;{{ $t("item") }}.
            <br />
            is {{ $t("free") }}:
            {{ F_And_B.oc_is_combo_free === "Y" ? " Yes" : "No" }}.&nbsp;
            <br />
            {{ $t("discount") }}: {{ F_And_B.oc_discount_value }}&nbsp;{{
              F_And_B.oc_discount_value_is_percentage === "Y" ? "%" : ""
            }}
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 align-self-center">
          <div class="all-details-container">
            <div class="col-12">
              <h3 class="text-blue font-weight-bold mb-3">
                {{ PromotionsDetailsObj.offer_title }}
              </h3>

              <div class="mb-4">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("code") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_code }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("start") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("end") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_applicable_on }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("name") }} :</span
                  >
                  {{ PromotionsDetailsObj.client_name }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("share") }}
                    {{ $t("vlaue") }} :</span
                  >
                  {{ PromotionsDetailsObj.share_value }}
                  {{
                    PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                  }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("redemptionOutlet") }} :</span
                  >
                  {{ $t("redeemAtOnline") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_online === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtConcession") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{ PromotionsDetailsObj.CinemasList }}.
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                  >
                  {{ PromotionsDetailsObj.ScreenList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                  >
                  {{ PromotionsDetailsObj.SeatTypesList }}.
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_movies === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{ PromotionsDetailsObj.MoviesList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("all") }}
                    {{ $t("days") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  class="mb-1"
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                  "
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offerValidOnDays") }} :</span
                  >
                  {{ PromotionsDetailsObj.DaysList }}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CUSTOMER CATEGORY OFFER -->
    <div
      v-if="selectedOfferType === 'customCategoryOffers'"
      class="voucher-card"
    >
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="all-details-container">
            <div class="col-12">
              <p class="mb-1">
                <span class="font-weight-bold mr-1"
                  >{{ $t("category") }} :</span
                >
                {{ customCategoryOffers.booking_user_category_id }}
              </p>
            </div>
          </div>
          <div class="voucher-label">
            {{ $t("validateby") }}: {{ customCategoryOffers.validate_doc_id }}
            <br />
            {{ $tc("minimumTicketAmount") }} :
            {{ customCategoryOffers.cco_min_ticket_amount }}
            <br />
            {{ $t("MaximumDiscountPerTransaction") }} :
            {{ customCategoryOffers.cco_max_discount_amount }}
            <br />
            {{ $t("offerprice") }} : {{ customCategoryOffers.cco_offer_value }}
            {{
              customCategoryOffers.cco_offer_value_is_percentage === "Y"
                ? "%"
                : ""
            }}
            <br />
            {{ $t("specialInstruction") }} :
            {{ customCategoryOffers.cco_instruction }}
            <br />
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 align-self-center">
          <div class="all-details-container">
            <div class="col-12">
              <h3 class="text-blue font-weight-bold mb-3">
                {{ PromotionsDetailsObj.offer_title }}
              </h3>

              <div class="mb-4">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("code") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_code }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("start") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("end") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_applicable_on }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("name") }} :</span
                  >
                  {{ PromotionsDetailsObj.client_name }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("share") }}
                    {{ $t("vlaue") }} :</span
                  >
                  {{ PromotionsDetailsObj.share_value }}
                  {{
                    PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                  }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("redemptionOutlet") }} :</span
                  >
                  {{ $t("redeemAtOnline") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_online === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtConcession") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{ PromotionsDetailsObj.CinemasList }}.
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                  >
                  {{ PromotionsDetailsObj.ScreenList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                  >
                  {{ PromotionsDetailsObj.SeatTypesList }}.
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_movies === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{ PromotionsDetailsObj.MoviesList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("all") }}
                    {{ $t("days") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  class="mb-1"
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                  "
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offerValidOnDays") }} :</span
                  >
                  {{ PromotionsDetailsObj.DaysList }}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BANK OFFERS -->
    <!-- this.bankOffer = {
            bank_id: DataRecords[0]["bank_id"],
            card_id: DataRecords[0]["card_id"],
            offerForDuration: "weekly",
            redemptionCount: null,
            bo_offer_value: DataRecords[0]["bo_offer_value"],
            bo_offer_value_is_percentage:
              DataRecords[0]["bo_offer_value_is_percentage"],
            bo_instruction: DataRecords[0]["bo_instruction"]
    };-->

    <div v-if="selectedOfferType === 'bankOffer'" class="voucher-card">
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="voucher-label">
            {{ $t("bank") }} : {{ bankOffer.bank_id }}
            <br />
            {{ $t("bank") }} {{ $t("cardname") }} : {{ bankOffer.card_id }}
            <br />
            {{ $t("bank") }} {{ $t("offer") }} {{ $t("validFor") }} :
            {{ bankOffer.offerForDuration }}
            <br />
            {{ $t("offerprice") }} : {{ bankOffer.bo_offer_value }}
            {{ bankOffer.bo_offer_value_is_percentage === "Y" ? "%" : "" }}
            <br />
            {{ $t("specialInstruction") }} : {{ bankOffer.bo_instruction }}
            <br />
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 align-self-center">
          <div class="all-details-container">
            <div class="col-12">
              <h3 class="text-blue font-weight-bold mb-3">
                {{ PromotionsDetailsObj.offer_title }}
              </h3>

              <div class="mb-4">
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("code") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_code }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("start") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("end") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                  >
                  {{ PromotionsDetailsObj.offer_applicable_on }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("name") }} :</span
                  >
                  {{ PromotionsDetailsObj.client_name }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("client") }} {{ $t("share") }}
                    {{ $t("vlaue") }} :</span
                  >
                  {{ PromotionsDetailsObj.share_value }}
                  {{
                    PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                  }}
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("redemptionOutlet") }} :</span
                  >
                  {{ $t("redeemAtOnline") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_online === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                      ? "Yes"
                      : "No"
                  }},&nbsp;{{ $t("redeemAtConcession") }} -
                  {{
                    PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_cinemas === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                  >
                  {{ PromotionsDetailsObj.CinemasList }}.
                </p>
                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                  >
                  {{ PromotionsDetailsObj.ScreenList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                  >
                  {{ PromotionsDetailsObj.SeatTypesList }}.
                </p>

                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'Y'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_movies === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>
                <p
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_movies === 'N'
                  "
                  class="mb-1"
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                  >
                  {{ PromotionsDetailsObj.MoviesList }}.
                </p>

                <p class="mb-1">
                  <span class="font-weight-bold mr-1"
                    >{{ $t("applicableOn") }} {{ $t("all") }}
                    {{ $t("days") }}:</span
                  >
                  {{
                    PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                      ? "Yes"
                      : "No"
                  }}
                </p>

                <p
                  class="mb-1"
                  v-if="
                    PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                  "
                >
                  <span class="font-weight-bold mr-1"
                    >{{ $t("offerValidOnDays") }} :</span
                  >
                  {{ PromotionsDetailsObj.DaysList }}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- promoCode
            booking_user_category_id: [], //////
            institution_id: DataRecords[0]["institution_id"] || "",
            promoCodeList: [],
    pcs_instruction: DataRecords[0]["pcs_instruction"] || ""-->

    <!-- promo_code: x["promo_code"] || null,
              pcs_no_of_transaction: x["pcs_no_of_transactions"] || null,
              pcs_min_ticket_amount: x["pcs_min_ticket_amount"] || null,
              pcs_max_discount_amount: x["pcs_max_discount_amount"] || null,
              pcs_offer_value: x["pcs_offer_value"] || null,
              pcs_offer_value_is_percentage:
    x["pcs_offer_value_is_percentage"] || "N"-->

    <!-- PROMO CODE -->
    <div v-if="selectedOfferType === 'promoCode'">
      <div class="all-details-container">
        <div class="col-12">
          <p class="mb-1">
            <span class="font-weight-bold mr-1">is Email:</span>
            {{ promoCode.pcs_send_email === "Y" ? "Yes" : "No" }}
          </p>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">is SMS:</span>
            {{ promoCode.pcs_send_sms === "Y" ? "Yes" : "No" }}
          </p>
          <p
            v-if="
              promoCode.promoCodeList.length > 0 &&
                promoCode.promoCodeList.length > 1
            "
            class="mb-1"
          >
            <span class="font-weight-bold mr-1">is Multiple Promo Code:</span>
            {{ promoCode.multiplePromocode === "Y" ? "Yes" : "No" }}
          </p>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">Promo Code Category:</span>
            {{ promoCode.booking_user_category_id }}
          </p>
          <p class="mb-1">
            <span class="font-weight-bold mr-1">Promo Code Instruction :</span>
            <span v-html="promoCode.pcs_instruction"></span>
          </p>
        </div>
      </div>

      <div
        class="voucher-card"
        v-for="(promoCodeItem, promoCodeIndex) in promoCode.promoCodeList"
        :key="promoCodeIndex"
      >
        <div class="row" style="font-size: 15px;">
          <div class="col-lg-5 col-xl-4">
            <div class="voucher-label">
              Promo Code: {{ promoCodeItem.promo_code }}
              <br />
              applicable for:
              {{ promoCodeItem.pcs_no_of_transaction }} Transactions
              <br />
              Minimum ticket amount : {{ promoCodeItem.pcs_min_ticket_amount }}
              <br />
              Maximum Discount Per Transaction :
              {{ promoCodeItem.pcs_max_discount_amount }}
              <br />
              Offer Price : {{ promoCodeItem.pcs_offer_value }}
              {{
                promoCodeItem.pcs_offer_value_is_percentage === "Y" ? "%" : ""
              }}
              <br />
            </div>
          </div>
          <div class="col-lg-7 col-xl-8 align-self-center">
            <div class="all-details-container">
              <div class="col-12">
                <h3 class="text-blue font-weight-bold mb-3">
                  {{ PromotionsDetailsObj.offer_title }}
                </h3>

                <div class="mb-4">
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("code") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_code }}
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("start") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_start_date_time | dateparse }}
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("end") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_end_date_time | dateparse }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offer") }} {{ $t("applicableOn") }} :</span
                    >
                    {{ PromotionsDetailsObj.offer_applicable_on }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("client") }} {{ $t("name") }} :</span
                    >
                    {{ PromotionsDetailsObj.client_name }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("client") }} {{ $t("share") }}
                      {{ $t("vlaue") }} :</span
                    >
                    {{ PromotionsDetailsObj.share_value }}
                    {{
                      PromotionsDetailsObj.share_is_percentage == "Y" ? "%" : ""
                    }}
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("redemptionOutlet") }} :</span
                    >
                    {{ $t("redeemAtOnline") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_online === "Y"
                        ? "Yes"
                        : "No"
                    }},&nbsp; {{ $t("redeemAtBoxoffice") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_boxoffice === "Y"
                        ? "Yes"
                        : "No"
                    }},&nbsp; {{ $t("redeemAtConcession") }} -
                    {{
                      PromotionsDetailsObj.offer_redeem_at_concession === "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>

                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                        'Y'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                      "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_cinemas ===
                        'N'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("cinemas") }} :</span
                    >
                    {{ PromotionsDetailsObj.CinemasList }}.
                  </p>
                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("screens") }} :</span
                    >
                    {{ PromotionsDetailsObj.ScreenList }}.
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("SeatType") }} :</span
                    >
                    {{ PromotionsDetailsObj.SeatTypesList }}.
                  </p>

                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                        'Y'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                      "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                  <p
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_movies ===
                        'N'
                    "
                    class="mb-1"
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("movies") }} :</span
                    >
                    {{ PromotionsDetailsObj.MoviesList }}.
                  </p>

                  <p class="mb-1">
                    <span class="font-weight-bold mr-1"
                      >{{ $t("applicableOn") }} {{ $t("all") }}
                      {{ $t("days") }} :</span
                    >
                    {{
                      PromotionsDetailsObj.offer_applicable_on_all_day === "Y"
                        ? "Yes"
                        : "No"
                    }}
                  </p>

                  <p
                    class="mb-1"
                    v-if="
                      PromotionsDetailsObj.offer_applicable_on_all_day === 'N'
                    "
                  >
                    <span class="font-weight-bold mr-1"
                      >{{ $t("offerValidOnDays") }} :</span
                    >
                    {{ PromotionsDetailsObj.DaysList }}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- END -->
  </div>
</template>

<script>
  //////////////
  //////////////
  import { generateRandomCode } from "@/helper/collection";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import moment from "moment";
  import PosFnBService from "@/services/Pos_Fnb_Service";
  import MarketingService from "@/services/MarketingService";
  import ClientService from "@/services/ClientService";

  export default {
    data() {
      return {
        cinema_manager_add_edit_disabled: null,
        value: "",
        selectedOfferType: "",

        PromotionsDetailsObj: {
          os_id: "",
          marketing_type_id: "",
          offer_type_id: "",
          offer_title: "",
          offer_code: "", // "PO-" + generateRandomCode(8),
          offer_start_date_time: "", // Start_Date,
          offer_end_date_time: "", // End_date,
          client_name: "",
          share_value: null,
          share_is_percentage: "Y",

          offer_redeem_at_online: "",
          offer_redeem_at_boxoffice: "",
          offer_redeem_at_concession: "",
          offer_applicable_on: "", // "gross_amount",

          // Cinemas
          CinemasList: "",
          ScreenList: "",
          SeatTypesList: "",
          MoviesList: "",
          DaysList: "",
          offer_applicable_on_all_cinemas: "",
          offer_applicable_on_all_day: "",
          offer_applicable_on_all_movies: "",
          offer_applicable_on_all_screens: "",
          offer_applicable_on_all_seat_types: "",
          offer_applicable_on_all_shows: "",
        },
        discountLists: [],

        buyAndGetFreeTickets: {
          oc_buy_no_of_ticket: null,
          oc_get_free_ticket: null,
          oc_min_ticket_price: null,
          oc_max_no_of_ticket_per_transaction: null,
          oc_combine_with_other_offers: "N",

          selectedCombineoffer: null,
        },
        boxOffice: {
          oc_buy_no_of_ticket: null,
          oc_get_item_id: null,
          oc_is_combo_free: "N",
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          amount: null,
        },
        offerApplicableAt: "",
        F_And_B: {
          oc_buy_item_count: null,
          oc_get_item_count: null,
          oc_buy_item_id: null,
          oc_get_item_id: null,
          // SelectedOnFnBItem: null,
          // SelectedFreeFnBItem: null,
          oc_is_combo_free: "N",
          oc_discount_value_is_percentage: "N",
          oc_discount_value: null,
        },
        customCategoryOffers: {
          booking_user_category_id: null, // "student",
          institution_id: null,
          validate_doc_id: null,
          cco_min_ticket_amount: null,
          cco_max_discount_amount: null,
          cco_offer_value: null,
          cco_offer_value_is_percentage: "N",
          cco_instruction: null,
        },
        promoCode: {
          pcs_send_email: "",
          pcs_send_sms: "",
          booking_user_category_id: "",
          institution_id: "",
          multiplePromocode: "",
          promoCodeList: [],
          pcs_instruction: "",
        },
        bankOffer: {
          bank_id: null,
          card_id: null,
          offerForDuration: "weekly",
          redemptionCount: null,
          bo_offer_value: null,
          bo_offer_value_is_percentage: null,
          bo_instruction: null,
        },
        // /////
        ///////
        //////

        ////

        // SAIF
        cinemasList: [],
        screenList: [],
        seatClassList: [],
        movieList: [],
        fnbItems: [],
        customerOffersCategories: [],
        institutionList: [],
        activeBankList: [],
        activeBankCardList: [],
        verificationList: [],

        // Cinemas Screen SeatClass

        OfferConfiguraion: {
          offer_applicable_on_all_cinemas: "N",
          selectedMovielist: [],
          pvms_start_show_time: "24:00:00",
          pvms_end_show_time: "23:59:59",

          // selectedMovie: null,
          // md_id: null,
          SelectedCinemas: null,
          cine_id: null,
          SelectedScreen: null,
          screen_id: null,
          SelectedClass: null,
          sst_id: null,
        },

        // SAIF END
      };
    },
    watch: {},
    beforeMount() {
      // let cinemaid =
      //   this.secureStore.get("USINFO") &&
      //   this.secureStore.get("USINFO")["cinema_id"]
      //     ? this.secureStore.get("USINFO").cinema_id
      //     : null;
      this.cinema_manager_add_edit_disabled = this.secureStore.get(
        "USINFO"
      ).role_id;
      const { os_id } = this.$route.query;
      if (os_id) {
        this.getPromotionsAndOffersDetails(os_id);
      } else {
        this.$router.go(-1);
      }

      // this.getCustomerOffersCategories();
    },
    computed: {
      getSelectedDays() {
        return Object.keys(this.weekDays)
          .map((x) => {
            if (this.weekDays[x]) return x;
          })
          .join(", ");
      },
      //
    },

    mounted() {},
    methods: {
      onEditPromotionOffer: function() {
        const { os_id } = this.$route.query;
        this.$router.push({
          path: "/marketing/edit-promotions-and-offers",
          query: { os_id: this.PromotionsDetailsObj.os_id },
        });
      },
      getPromotionsAndOffersDetails: function(os_id) {
        let loader = this.$loading.show();

        MarketingService.GetSinglePermotiosAndOffers({ offertypeid: os_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                let Records = data.Records[0];
                this.setOfferDaysValue(
                  Records["offer_applicable_on_all_day"],
                  data.PromotionOfferDaysRecords
                );
                this.setOfferType(
                  Records,
                  data["PromotionOfferTypesRecords"],
                  data["PromotionOfferBuyItems"],
                  data["PromotionOfferGetItems"]
                );
                if (Records.client_id) {
                  this.setClientName(Records.client_id);
                }
                this.PromotionsDetailsObj = {
                  ...this.PromotionsDetailsObj,
                  os_id: Records.os_id,
                  marketing_type_id: Records.marketing_type_id,
                  offer_type_id: Records.offer_type_id,
                  offer_title: Records.offer_title,
                  offer_code: Records.offer_code,
                  offer_start_date_time: Records.offer_start_date_time, // Start_Date,
                  offer_end_date_time: Records.offer_end_date_time, // End_date,

                  share_value: Records.client_share_value || null,
                  share_is_percentage:
                    Records.client_share_is_percentage || "Y",

                  offer_redeem_at_online: Records.offer_redeem_at_online || "",
                  offer_redeem_at_boxoffice:
                    Records.offer_redeem_at_boxoffice || "",
                  offer_redeem_at_concession:
                    Records.offer_redeem_at_concession || "",
                  offer_applicable_on: "",

                  offer_applicable_on_all_cinemas:
                    Records.offer_applicable_on_all_cinemas,
                  offer_applicable_on_all_movies:
                    Records.offer_applicable_on_all_movies || "",
                  offer_applicable_on_all_day:
                    Records.offer_applicable_on_all_day || "",
                  offer_applicable_on_all_screens:
                    Records.offer_applicable_on_all_screens || "",
                  offer_applicable_on_all_seat_types:
                    Records.offer_applicable_on_all_seat_types || "",
                  offer_applicable_on_all_shows:
                    Records.offer_applicable_on_all_shows || "",
                };
                if (
                  Records["offer_applicable_on_gross_amount"] &&
                  Records["offer_applicable_on_gross_amount"] === "Y"
                ) {
                  this.PromotionsDetailsObj["offer_applicable_on"] =
                    "Gross Amount";
                } else if (
                  Records["offer_applicable_on_net_amount"] &&
                  Records["offer_applicable_on_net_amount"] === "Y"
                ) {
                  this.PromotionsDetailsObj["offer_applicable_on"] =
                    "Net Amount";
                }
                if (
                  data.PromotionOfferCinemasRecords &&
                  data.PromotionOfferCinemasRecords.length > 0
                ) {
                  this.PromotionsDetailsObj.CinemasList = data.PromotionOfferCinemasRecords.map(
                    (x) => x.cine_name
                  ).join(", ");
                  this.PromotionsDetailsObj.ScreenList = data.PromotionOfferCinemasRecords.map(
                    (x) => (x.screen_name ? x.screen_name : "All")
                  ).join(", ");
                  this.PromotionsDetailsObj.SeatTypesList = data.PromotionOfferCinemasRecords.map(
                    (x) => (x.sst_seat_type ? x.sst_seat_type : "All")
                  ).join(", ");
                }

                if (
                  data.PromotionOfferMoviesRecords &&
                  data.PromotionOfferMoviesRecords.length > 0
                ) {
                  this.PromotionsDetailsObj.MoviesList = data.PromotionOfferMoviesRecords.map(
                    (x) => x.movie_title
                  ).join(", ");
                }
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1500);
          });
      },
      setClientName: function(client_id) {
        ClientService.GetSingleClientDetails({ client_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              let obj = data.Records[0];
              this.PromotionsDetailsObj.client_name = obj.client_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      setOfferType: function(
        Records,
        DataRecords,
        OfferBuyItems,
        OfferGetItems
      ) {
        if (Records["offer_type_id"] && Records.offer_type_id === 1) {
          this.selectedOfferType = "buyAndGetFreeTickets";
          if (DataRecords && DataRecords.length > 0) {
            this.buyAndGetFreeTickets = {
              oc_buy_no_of_ticket:
                DataRecords[0]["oc_buy_no_of_ticket"] || null,
              oc_get_free_ticket: DataRecords[0]["oc_get_free_ticket"] || null,
              oc_min_ticket_price:
                DataRecords[0]["oc_min_ticket_price"] || null,
              oc_max_no_of_ticket_per_transaction:
                DataRecords[0]["oc_max_no_of_ticket_per_transaction"] || null,
              oc_combine_with_other_offers: "N",
              selectedCombineoffer: null,
            };
          }
        } else if (Records["offer_type_id"] && Records.offer_type_id === 2) {
          this.selectedOfferType = "discount";

          if (DataRecords && DataRecords.length > 0) {
            this.discountLists = [];
            DataRecords.map((x) => {
              this.discountLists.push({
                oc_buy_no_of_ticket: x["oc_buy_no_of_ticket"] || "",
                oc_discount_value: x["oc_discount_value"] || "",
                oc_discount_value_is_percentage:
                  x["oc_discount_value_is_percentage"] || "N",
                oc_max_discount_amount: x["oc_max_discount_amount"] || null,

                canCombineOtherOffers: "N",
                selectedCombinedOffer: null,
              });
            });
          }
        } else if (Records["offer_type_id"] && Records.offer_type_id === 3) {
          this.selectedOfferType = "buyAndGetCombo";
          if (
            DataRecords &&
            DataRecords.length > 0 &&
            DataRecords[0]["oc_buy_no_of_ticket"] &&
            !DataRecords[0]["oc_buy_item_id"]
          ) {
            this.offerApplicableAt = "boxOffice";
            this.boxOffice = {
              oc_buy_no_of_ticket:
                DataRecords[0]["oc_buy_no_of_ticket"] || null,
              oc_get_item_id:
                OfferGetItems && OfferGetItems.length > 0
                  ? OfferGetItems[0].item_name
                  : "", //// DataRecords[0]["oc_get_item_id"] || null,
              oc_is_combo_free: DataRecords[0]["oc_is_combo_free"] || "",
              oc_discount_value: DataRecords[0]["oc_discount_value"] || null,
              oc_discount_value_is_percentage:
                DataRecords[0]["oc_discount_value_is_percentage"] || "N",
              amount: null,
            };
          } else if (
            DataRecords &&
            DataRecords.length > 0 &&
            !DataRecords[0]["oc_buy_no_of_ticket"] &&
            DataRecords[0]["oc_buy_item_id"]
          ) {
            this.offerApplicableAt = "fAndb";
            this.F_And_B = {
              oc_buy_item_count: DataRecords[0]["oc_buy_item_count"],
              oc_get_item_count: DataRecords[0]["oc_get_item_count"],
              oc_buy_item_id:
                OfferBuyItems && OfferBuyItems.length > 0
                  ? OfferBuyItems[0].item_name
                  : "",
              oc_get_item_id:
                OfferGetItems && OfferGetItems.length > 0
                  ? OfferGetItems[0].item_name
                  : "",
              // SelectedOnFnBItem: null,
              // SelectedFreeFnBItem: null,
              oc_discount_value_is_percentage:
                DataRecords[0]["oc_discount_value_is_percentage"] || "N",
              oc_is_combo_free: DataRecords[0]["oc_is_combo_free"] || "N",
              oc_discount_value: DataRecords[0]["oc_discount_value"],
            };
          }
        } else if (Records["offer_type_id"] && Records.offer_type_id === 4) {
          this.selectedOfferType = "customCategoryOffers";
          if (DataRecords && DataRecords.length > 0) {
            this.customCategoryOffers = {
              booking_user_category_id: DataRecords[0]["buc_category_name"], // "student",
              institution_id: DataRecords[0]["institution_id"],
              validate_doc_id: null,
              cco_min_ticket_amount: DataRecords[0]["cco_min_ticket_amount"],
              cco_max_discount_amount:
                DataRecords[0]["cco_max_discount_amount"],
              cco_offer_value: DataRecords[0]["cco_offer_value"],
              cco_offer_value_is_percentage:
                DataRecords[0]["cco_offer_value_is_percentage"] || "N",
              cco_instruction: DataRecords[0]["cco_instruction"],
            };
            this.getVerificationList(DataRecords[0]["validate_doc_id"]);
          }
        } else if (Records["offer_type_id"] && Records.offer_type_id === 5) {
          this.selectedOfferType = "bankOffer";
          if (DataRecords && DataRecords.length > 0) {
            this.bankOffer = {
              bank_id: DataRecords[0]["bank_name"],
              card_id: DataRecords[0]["card_type"],
              offerForDuration: "",
              redemptionCount: null,
              bo_offer_value: DataRecords[0]["bo_offer_value"],
              bo_offer_value_is_percentage:
                DataRecords[0]["bo_offer_value_is_percentage"],
              bo_instruction: DataRecords[0]["bo_instruction"],
            };
            if (
              DataRecords[0]["bo_weekly_redemption"] &&
              String(DataRecords[0]["bo_weekly_redemption"]).length > 0
            ) {
              this.bankOffer.offerForDuration = "weekly";
              this.bankOffer.redemptionCount =
                DataRecords[0]["bo_weekly_redemption"];
            } else if (
              DataRecords[0]["bo_monthly_redemption"] &&
              String(DataRecords[0]["bo_monthly_redemption"]).length > 0
            ) {
              this.bankOffer.offerForDuration = "monthly";
              this.bankOffer.redemptionCount =
                DataRecords[0]["bo_monthly_redemption"];
            } else if (
              DataRecords[0]["bo_yearly_redemption"] &&
              String(DataRecords[0]["bo_yearly_redemption"]).length > 0
            ) {
              this.bankOffer.offerForDuration = "yearly";
              this.bankOffer.redemptionCount =
                DataRecords[0]["bo_yearly_redemption"];
            }
          }
        } else if (Records["offer_type_id"] && Records.offer_type_id === 6) {
          this.selectedOfferType = "promoCode";
          if (DataRecords && DataRecords.length > 0) {
            this.promoCode = {
              pcs_send_email: DataRecords[0]["pcs_send_email"] || "N",
              pcs_send_sms: DataRecords[0]["pcs_send_sms"] || "N",
              booking_user_category_id: [], //////
              institution_id: DataRecords[0]["institution_id"] || "",
              multiplePromocode: "",
              promoCodeList: [],
              pcs_instruction: DataRecords[0]["pcs_instruction"] || "",
            };
            this.promoCode.multiplePromocode = "Y";

            DataRecords.map((x) => {
              this.promoCode.promoCodeList.push({
                promo_code: x["promo_code"] || null,
                pcs_no_of_transaction: x["pcs_no_of_transactions"] || null,
                pcs_min_ticket_amount: x["pcs_min_ticket_amount"] || null,
                pcs_max_discount_amount: x["pcs_max_discount_amount"] || null,
                pcs_offer_value: x["pcs_offer_value"] || null,
                pcs_offer_value_is_percentage:
                  x["pcs_offer_value_is_percentage"] || "N",
              });
            });
            this.getCustomerOffersCategories(
              DataRecords[0]["booking_user_category_id"]
            );
          }
        }
      },
      setOfferDaysValue: function(alldays, voucherDays) {
        this.PromotionsDetailsObj["DaysList"] = "";
        let days = {
          sunday: "pvds_sunday",
          monday: "pvds_monday",
          tuesday: "pvds_tuesday",
          wednesday: "pvds_wednesday",
          thursday: "pvds_thursday",
          friday: "pvds_friday",
          saturday: "pvds_saturday",
        };
        Object.keys(days).map((x, index) => {
          let text = index !== Object.keys(days).length - 1 ? x + ", " : x;
          if (alldays && alldays === "Y") {
            this.PromotionsDetailsObj["DaysList"] += text;
          } else if (
            voucherDays &&
            voucherDays.length > 0 &&
            voucherDays[0][days[x]] === "Y"
          ) {
            this.PromotionsDetailsObj["DaysList"] += text;
          }
        });
      },

      getActiveMovies: function(isAllMovies, DataMoviesList) {
        this.movieList = [];
        MovieService.GetActiveMoviesWithFormat()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.movieList = data.Records;

                if (
                  isAllMovies &&
                  isAllMovies === "N" &&
                  DataMoviesList &&
                  DataMoviesList.length > 0
                ) {
                  data.Records.map((x, index) => {
                    if (index) {
                      this.OfferConfiguraion.pvms_start_show_time =
                        x.pvms_start_show_time;
                      this.OfferConfiguraion.pvms_end_show_time =
                        x.pvms_end_show_time;
                    }
                    let findIndex = DataMoviesList.findIndex(
                      (z) => x.md_id === z.movie_detail_id
                    );
                    findIndex !== -1
                      ? this.OfferConfiguraion.selectedMovielist.push(x)
                      : "";
                  });
                }
              }
            } else {
              // Show Error Message
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getCustomerOffersCategories: function(DataCategory) {
        MarketingService.GetCustomerCategories()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              if (data.Records.length > 0) {
                this.customerOffersCategories = data.Records;
                if (DataCategory && String(DataCategory).length > 0) {
                  this.promoCode.booking_user_category_id = "";
                  let arrayList = DataCategory.split(", ");
                  data.Records.map((x) => {
                    let findIndex = arrayList.findIndex(
                      (z) => z === String(x.buc_id)
                    );
                    if (findIndex !== -1) {
                      // this.promoCode.booking_user_category_id.push(x);
                      let text =
                        this.promoCode.booking_user_category_id.length > 0
                          ? `, ${x.buc_category_name}`
                          : `${x.buc_category_name}`;
                      this.promoCode.booking_user_category_id += text;
                    }
                  });
                } else {
                  this.customCategoryOffers.booking_user_category_id =
                    data.Records[0].buc_id;
                }
              }
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },

      getVerificationList: function(DataList) {
        MarketingService.GetVerificationList()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.verificationList = data.Records;
                if (DataList && DataList.length > 0) {
                  let arraylist = DataList.split(", ");
                  this.customCategoryOffers.validate_doc_id = "";
                  data.Records.map((x, index) => {
                    let findIndex = arraylist.findIndex(
                      (z) => String(x.vd_id) === z
                    );
                    if (findIndex !== -1) {
                      let text =
                        this.customCategoryOffers.validate_doc_id.length > 0
                          ? `, ${x.vd_document_name}`
                          : `${x.vd_document_name}`;
                      this.customCategoryOffers.validate_doc_id += text;
                    }
                  });
                }
              }
            } else this.$toasted.show(data.message || this.AdminError);
          })
          .catch(this._CatchError);
      },
    },
  };
</script>

<style>
  .voucher-card {
    width: 100%;
    overflow: hidden;
    border-radius: 10px;
    background-color: #fff;
    font-size: 18px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .offet-type {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    font-variant: small-caps;
    letter-spacing: 1px;
    border-bottom: 1px solid;
  }

  .voucher-label {
    /*font-size: 30px;*/
    font-size: 16px;
    padding: 30px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: 1px;
    font-weight: bolder;
    text-transform: uppercase;
    color: #fff;
    background: #7f7fd5;
    background: linear-gradient(500deg, #91eae4, #42a1e4, var(--blue));
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/detailsPromotionsAndOffers.vue